import { Sidebar } from '@/components/layout/Sidebar';
import { Header } from '@/components/layout/Header';

interface MainLayoutProps {
  children: React.ReactNode;
  fullScreen?: boolean; // For pages that need full width/height (e.g., Power BI reports)
}

export const MainLayout = ({ children, fullScreen = false }: MainLayoutProps) => {
  return (
    <div className="flex min-h-screen bg-gray-50 dark:bg-dark-950">
      {/* Sidebar */}
      <Sidebar />

      {/* Main content area */}
      <div className="flex min-w-0 flex-1 flex-col lg:ml-[17rem]">
        {/* Header */}
        <Header />

        {/* Main Content */}
        <main className={fullScreen ? 'flex-1' : 'flex-1 px-6 py-4 sm:p-6 lg:px-8'}>
          {fullScreen ? children : <div className="page-max-width w-full">{children}</div>}
        </main>

        {/* Footer */}
        <footer className="safe-bottom border-t border-gray-200 bg-white py-4 dark:border-dark-700 dark:bg-dark-900">
          <div className="page-max-width w-full px-6">
            <p className="text-center text-sm text-gray-500 dark:text-gray-400">
              © {new Date().getFullYear()} Extranet. All rights reserved.
            </p>
          </div>
        </footer>
      </div>
    </div>
  );
};
